<template>
  <div v-if="metric.value" class="block text-right">
    <div class="w-full flex flex-row flex-grow-0 items-center justify-between font-montserrat">
      <span v-text="metric.name"></span>
      <div>
        <span v-if="metric.prefix" v-text="metric.prefix"></span>
        <span class="text-xl" v-text="metric.value"></span>
        <span v-if="metric.suffix" v-text="metric.suffix"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    metric: {
      type: Object,
      required: true,
    },
  },
};
</script>
